import React from 'react';
import { ZfBanner, ZfBox } from '@zafire/react';

type Props = {
  testId: string;
  type: 'warning' | 'info';
  titleText: string;
  description: string;
};

export const ConfigureProductModalBanner: React.FC<Props> = ({ testId, type, titleText, description }) => (
  <ZfBox style={{ marginBottom: 'var(--zf-spacing-small, 12px)' }}>
    <ZfBanner data-testid={testId} type={type} titleText={titleText} description={description} dismissible={false} />
  </ZfBox>
);
